import { renderDateMacros } from '@orn/global/assistant/dateMacro.js';
import { PACIFIC_TIME_ZONE } from '@orn/shared-web/utils/datetime/formatInstantInTimeZone';

/**
 * A work item's `body` as an operator reads it, with its date macros resolved.
 *
 * `user_body` is plain text apart from one token it may carry: a `<date=… />`
 * the writer stored in place of a fixed day. Printing the column straight puts
 * that token on screen verbatim, so every plain-text consumer owes this pass.
 *
 * Pacific because every other instant on the admin surface is, so a card
 * saying "today" agrees with the timestamps drawn beside it.
 */
export function renderWorkItemBody(body: string | null, now: Date = new Date()): string | null {
  if (body === null) {
    return null;
  }
  return renderDateMacros(body, { now, timeZone: PACIFIC_TIME_ZONE });
}
